import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createPurchasesReportSlice = (set, get) => ({
    purchases: {
        loading: false,
        data: []
    },
    getUserPurchases: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ purchases: { ...state.purchases, loading: true } }));
        try {
            const res = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: "/v1/business/user-purchases-report",
                data: {
                    UserId: param.UserId,
                    fromDate: param.fromDate,
                    toDate: param.toDate,
                },
                headers: { token },
            });
            set(state => ({ purchases: { loading: false, data: res.data } }));
        } catch (error) {
            set(state => ({ purchases: { ...state.purchases, loading: false } }));
        }
    }
});
